import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import MetaTags from 'react-meta-tags';
import PayCard from './PayCard/PayCard';

import s from './Good.module.scss';
import './Good.scss';
import { fetchOrderAndGoods } from '../../Actions/getOrderAndGoods';
import { fetchTranslation } from '../../Actions/getTranslation';
import ImageGallery from './ImageGallery';
import OtherGoods from './OtherGoods/OtherGoods';
import DetailedDescription from '../../components/Good/DetailedDescription/DetailedDescription';
import Description from './Description';
import Loader from '../../components/Loader/Loader';

const Good = props => {
  const { id } = props.match.params;
  if (!id) {
    window.location = `/good/${localStorage.getItem('idGood')}`;
  }
  localStorage.setItem('idGood', id);
  const { getOrderAndGoods, getTranslation, goods, t } = props;

  useEffect(() => {
    getOrderAndGoods();
    getTranslation();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!Object.keys(goods).length || !t) return <Loader />;

  const goodData =
    goods[id] || Object.values(goods).find(i => i.seo_url === id);

  if (!goodData) {
    return <h4>{t['Товар не найден']}</h4>;
  }

  const lang = t.language;
  const goodLocData = goodData.locData[lang];

  if (!goodLocData) {
    console.log('Невозможно получить данные');
    return <Loader />;
  }

  const siteUrl = window.location.origin;
  const productUrl = `${siteUrl}/good/${id}`;
  const productImg = `${siteUrl}${goodData.img.src}`;
  const schema = `{
    "@context": "http://schema.org/",
    "@type": "Product",
    "name": "${goodLocData.name}",
    "image": "${productImg}",
    "description": "${goodLocData.seo_description}",
    "brand": {
      "@type": "Brand",
      "name": "${goodLocData.manufacturer}" 
    },
    "offers": {
      "@type": "Offer",
      "priceCurrency": "RUB",
      "price": "${goodData.cost}",
      "url": "${productUrl}",
      "availability": "https://schema.org/InStock",
      "itemCondition": "https://schema.org/NewCondition" 
    }
  }`;

  return (
    <section className={s.main}>
      <MetaTags>
        {/* <title>{goodLocData.seo_title}</title>
        <link rel="canonical" href={window.location.href} />
        <meta name="description" content={goodLocData.seo_description} />
        <meta name="keywords" content={goodLocData.seo_keywords} />
        <meta property="og:type" content="product" />
        <meta property="og:title" content={goodLocData.seo_title} />
        <meta property="og:description" content={goodLocData.seo_description} />
        <meta property="og:url" content={productUrl} /> */}
        <meta property="og:image" content={productImg} />
        <meta property="product:price.amount" content={goodData.cost} />
        <meta property="product:price.currency" content="RUB" />
        <meta
          property="og:site_name"
          content="КардиоОблако. ЭКГ в домашних условиях"
        />
        <meta property="og:locale" content={lang} />
        <meta property="fb:app_id" content="1668564593403729" />
        <script type="application/ld+json">{schema}</script>
      </MetaTags>
      <div className={s.title}>
        <h1 dangerouslySetInnerHTML={{ __html: goodLocData.name }} />
      </div>
      <ImageGallery imagesArr={[goodData.img, ...goodLocData.imgs]} t={t} />
      <Description goodData={goodLocData} t={t} />
      <div className={s.payCardBox}>
        {/* id 31 карточка автоанализа */}
        {id !== '31' && (
          <PayCard id={goodData.id} goodData={goodLocData} t={t} />
        )}
      </div>
      <div className={s.otherGoods}>
        <OtherGoods id={goodData.id} />
      </div>
      <div className={s.detailedDescription}>
        <DetailedDescription goodData={goodLocData} t={t} />
      </div>
    </section>
  );
};

Good.defaultProps = {
  getGoods: PropTypes.func,
  getTranslation: PropTypes.func,
  getCurrentOrder: PropTypes.func
};

const mapStateToProps = state => ({
  goods: state.goods,
  t: state.translation
});

const mapDispatchToProps = {
  getTranslation: fetchTranslation,
  getOrderAndGoods: fetchOrderAndGoods
};

export default connect(mapStateToProps, mapDispatchToProps)(Good);
